import axios from "../../../../login/Axios-interceptor";
import { toast } from "react-toastify";
import { BASE_URL, API_TIMEOUT_MS } from "./config";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

function ss(key) {
  const v = sessionStorage.getItem(key);
  return v && v !== "null" && v !== "undefined" ? v : null;
}

function unwrap(response) {
  const { data } = response;
  if (!data) return data;
  if (data.status === "Failed") {
    const msg = data.message || "Request failed";
    throw new Error(msg);
  }
  if (Object.prototype.hasOwnProperty.call(data, "data") && data.data !== undefined) {
    return data.data;
  }
  return data;
}

/** Returns the full API body without unwrapping nested `data`. */
function unwrapFull(response) {
  const { data } = response;
  if (!data) return data;
  if (data.status === "Failed") {
    const msg = data.message || "Request failed";
    throw new Error(msg);
  }
  return data;
}

function buildRequestConfig(config = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...(config.headers || {}),
  };

  const token = ss("accessToken");
  if (token) headers.Authorization = `Bearer ${token}`;

  return {
    baseURL: BASE_URL,
    timeout: API_TIMEOUT_MS,
    ...config,
    headers,
  };
}

function onError(err, { silent = false } = {}) {
  const msg = getApiErrorMessage(err);
  // if (!silent) toast.error(msg);
  const wrapped = new Error(msg);
  wrapped.original = err;
  throw wrapped;
}

const client = {
  get: (path, params, options) =>
    axios.get(path, buildRequestConfig({ params })).then(unwrap).catch((e) => onError(e, options)),
  post: (path, body, options) =>
    axios.post(path, body, buildRequestConfig()).then(unwrap).catch((e) => onError(e, options)),
  postFull: (path, body, options) =>
    axios.post(path, body, buildRequestConfig()).then(unwrapFull).catch((e) => onError(e, options)),
  patch: (path, body, options) =>
    axios.patch(path, body, buildRequestConfig()).then(unwrap).catch((e) => onError(e, options)),
  put: (path, body, options) =>
    axios.put(path, body, buildRequestConfig()).then(unwrap).catch((e) => onError(e, options)),
  delete: (path, params, options) =>
    axios.delete(path, buildRequestConfig({ params })).then(unwrap).catch((e) => onError(e, options)),
};

export default client;
export { axios as ipdAdmissionAxios };
